export default __webpack_public_path__ + "resources/icons/d411-c267.png";